import React, { Fragment, useState, useEffect } from "react";
import styled from "styled-components";
import Sidebar from "./Sidebar";
import Content from "./Content";
import Modals from "./Modals";
import MobileNav from "./MobileNav";
import { BiMenuAltLeft } from "react-icons/bi";

const Index = ({ children }) => {
  const [showNav, setShowNav] = useState(false);

  return (
    <Fragment>
      <Container id="container">
        <Modals />
        <Sidebar />
        {showNav && <MobileNav setShow={setShowNav} show={showNav} />}
        <Content>{children}</Content>
      </Container>
      <MobileMenuBar
        onClick={() => {
          setShowNav(true);
        }}
      >
        <BiMenuAltLeft />
      </MobileMenuBar>
    </Fragment>
    // test
  );
};
export default Index;

const Container = styled.div`
  position: relative;
`;

const MobileMenuBar = styled.div`
  display: none;

  @media only screen and (max-width: 1000px) {
    display: unset;
    position: absolute;
    top: 0px;
    /* right: 20px; */
    cursor: pointer;
    /* border: 1px solid; */
    width: 100vw;
    box-shadow: 0px 3px 9px 1px rgba(0, 0, 0, 0.18);
    -webkit-box-shadow: 0px 3px 9px 1px rgba(0, 0, 0, 0.18);
    -moz-box-shadow: 0px 3px 9px 1px rgba(0, 0, 0, 0.18);
    background-color: #fbfbfb;
    svg {
      font-size: 50px;
      margin: 10px;
      color: #525252;
    }
  }
`;
